<template>
  <div class="flex min-h-screen bg-primaryBg font-inter">
    <aside class="hidden md:block w-[294px] flex-shrink-0 bg-primaryBg text-primaryDark">
      <Sidebar />
    </aside>
    <div class="flex-grow">
      <main class="w-full">
        <Settings />
      </main>
      </div>
    </div>
  </template>
  
  <script>
  import Sidebar from '@/components/SidebarComponent.vue';
  import Settings from '@/components/settings/SettingsComponents.vue';
  
  export default {
    name: 'SettingsView',
    components: {
      Sidebar,
      Settings,
    },
  };
  </script>
  
  <style scoped>
  /* Add any layout styles here */
  </style>
  